import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p411756259739451392',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
